export const WEBAPI_URI="https://api.robthegamedev.com";
export const S3_BUCKET="https://robthegamedev.s3.us-west-2.amazonaws.com/";
export const GOOGLE_ANALYTICS_TRACKING_ID="G-T31NT6PX5V";
export const RECAPTCHA_KEY="6LfxQt0iAAAAAN7qHs2ozI3K751oOWQ6kcuhYh1i";
